import { combineActions, handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import { filtersActions } from '../filters';
import * as actions from './spendingWatchlistActions';
import { mkSpendingWatchListStore } from './spendingWatchlistTypes';

export const spendingWatchlistReducer = handleActions(
  {
    // FIXME: either remove these or change them to set the loading state to true
    [combineActions(
      actions.getSpendingWatchLists,
      actions.createSpendingWatchList,
      actions.updateSpendingWatchList,
      actions.deleteSpendingWatchList,
    )]: (state) => state,

    [combineActions(actions.getSpendingWatchListsSuccess)]: (state, { payload: data }) =>
      resourceUpserters.upsertResources(state, data),

    [combineActions(
      actions.createSpendingWatchListSuccess,
      actions.updateSpendingWatchListSuccess,
      actions.deleteSpendingWatchListSuccess,
    )]: (state, { payload: spendingWatchListToUpsert }) =>
      resourceUpserters.upsertResource(state, spendingWatchListToUpsert),

    [combineActions(
      actions.getSpendingWatchListsFailure,
      actions.createSpendingWatchListFailure,
      actions.updateSpendingWatchListFailure,
      actions.deleteSpendingWatchListFailure,
    )]: (state, { payload: _error }) =>
      // todo: what else should we do with the failure?
      state,

    [filtersActions.updateFilterSuccess]: (state, { asyncDispatch }) => {
      asyncDispatch(actions.getSpendingWatchLists());
      return state;
    },
  },
  mkSpendingWatchListStore(),
);
